<script setup lang="ts">
import { onMounted, ref } from 'vue';

import { InputFailedEvent } from '@/components/base/form/InlineError.vue';
import PasswordInput from '@/components/base/form/PasswordInput.vue';
import Radio from '@/components/base/form/Radio.vue';
import { CheckoutEvents } from '@/utils/analytics';

const newPassword = defineModel<string>('password');
const isB2bCustomer = defineModel<boolean>('isB2b');

const showAccountType = ref(true);

onMounted(async () => {
  if (isB2bCustomer.value) showAccountType.value = false;
});

const onPasswordInputFailed = ({ field, error }: InputFailedEvent) => {
  CheckoutEvents.validation({ stepNumber: 4, field, error });
};
</script>

<template>
  <div>
    <div class="align-middle">
      <strong class="mr-2 text-lg leading-5 md:text-xl">Create an Account</strong>
      <span class="text-sm leading-5 text-neutral-500 md:text-base">(optional)</span>
    </div>
    <div class="mt-2 text-sm text-black md:pr-2">
      <p>Checkout faster, track your packages, create favorites &amp; more!</p>
    </div>

    <div
      v-if="showAccountType"
      class="flex mt-3"
      aria-label="Account Type"
      data-test="account-type-selector"
      role="radiogroup"
    >
      <div class="mr-5">
        <Radio
          v-model="isB2bCustomer"
          aria-label="Personal"
          class="text-base"
          name="account-type"
          :value="false"
        >
          Personal
        </Radio>
      </div>
      <div class="mr-5">
        <Radio
          v-model="isB2bCustomer"
          aria-label="Business"
          class="text-base"
          name="account-type"
          :value="true"
        >
          Business
        </Radio>
      </div>
    </div>

    <div class="grid grid-cols-1 gap-5 mt-2 md:grid-cols-1">
      <PasswordInput v-model="newPassword" @input-failed="onPasswordInputFailed" />
    </div>
  </div>
</template>
